import { cx } from '@/utils/strings'
import { motion, useReducedMotion } from 'framer-motion'
import { useMediaQuery } from 'usehooks-ts'

export default function Laptop() {
  const shouldReduceMotion = useReducedMotion()
  const isMobile = useMediaQuery('(max-width: 768px)')
  const isAnimated = !shouldReduceMotion && !isMobile
  return (
    <div
      className={cx(
        `hidden relative z-2 items-center w-full h-auto scale-125 origin-bottom-left`,
        `md:flex md:w-auto md:h-full md:ml-auto md:top-[0%] md:right-[0%] md:scale-[1.3]`,
        `lg:scale-125 lg:top-[-5%] lg:right-[-10%]`,
        `2xl:scale-[1.30] 2xl:min-h-[800px] 2xl:origin-left 2xl:right-[-10%] 2xl:bottom-[-50%] 2xl:translate-y-[calc(-50%_-_max(22.5%,_200px))] 2xl:top-auto`,
        `[&_svg]:fill-none [&_svg]:w-full [&_svg]:max-h-full ml-auto`
      )}
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -200 1195 980">
        {/* Laptop */}
        <g>
          <path
            fill="#175DDC"
            d="m6 635 1 11c1 12 8 21 19 24l487 109c5 1 10 0 15-2l182-116c7-4 11-12 11-21v-15l18-144L6 635Z"
            opacity=".2"
          />
          <path
            fill="#020F66"
            d="m0 625 1 12c0 11 8 21 19 23l487 110c5 1 10 0 14-3l183-115c7-5 11-13 11-21v-15L0 625Z"
          />
          <path fill="#175DDC" d="m0 625 278-69 437 60-200 120L0 625Z" />
          <path
            fill="#1A41AC"
            d="m335 278 434-16c4 0 6 3 6 6l-57 344c-1 3-4 5-7 5l-433-58c-3 0-5-3-4-7l55-270c1-2 3-4 6-4Z"
          />
          <path fill="#175DDC" d="m351 296 391-12 2 2-50 304c-1 3-4 5-7 5l-385-52c-3 0-5-3-4-6l48-236c1-3 3-5 5-5Z" />
          <path
            fill="#1A41AC"
            d="m144 642 79-22h1l147 32c2 0 2 4 0 4l-80 25h-1l-146-35c-2-1-2-4 0-4Zm26-42 406 81h1l85-52c2-1 1-4-1-4l-400-56h-1l-90 26c-2 1-2 4 0 5Z"
          />
        </g>
        {/* Password Field */}
        <g filter="url(#laptop-group)">
          <path fill="#fff" d="M517 326H198a34 34 0 0 0 0 67h319a34 34 0 1 0 0-67Z" />
          <path
            fill="#175DDC"
            d="m505 372 1-10-8 6-3-4 9-4-9-4 2-5 9 6-1-10h5l-1 10 8-6 2 5-9 4 9 4-2 4-8-6 1 10h-5Zm-34 0 1-10-8 6-2-4 9-4-9-4 2-5 9 6-2-10h6l-1 10 8-6 2 5-9 4 9 4-2 4-8-6 1 10h-6Zm-33 0 1-10-8 6-3-4 10-4-10-4 3-5 8 6-1-10h5l-1 10 8-6 3 5-9 4 9 4-3 4-8-6 1 10h-5Zm-33 0 1-10-8 6-3-4 9-4-9-4 3-5 8 6-1-10h5l-1 10 8-6 3 5-10 4 10 4-3 4-8-6 1 10h-5Zm-33 0 1-10-8 6-3-4 9-4-9-4 2-5 9 6-1-10h5l-1 10 8-6 2 5-9 4 9 4-2 4-8-6 1 10h-5Zm-34 0 1-10-8 6-2-4 9-4-9-4 2-5 8 6-1-10h6l-2 10 9-6 2 5-9 4 9 4-2 4-9-6 2 10h-6Zm-33 0 1-10-8 6-3-4 10-4-10-4 3-5 8 6-1-10h5l-1 10 8-6 3 5-9 4 9 4-3 4-8-6 1 10h-5Zm-33 0 1-10-8 6-3-4 9-4-9-4 3-5 8 6-1-10h5l-1 10 8-6 3 5-10 4 10 4-3 4-8-6 1 10h-5Zm-33 0 1-10-9 6-2-4 9-4-9-4 2-5 9 6-1-10h5l-1 10 8-6 2 5-9 4 9 4-2 4-8-6 1 10h-5Zm-34 0 1-10-8 6-2-4 9-4-9-4 2-5 8 6-1-10h6l-2 10 9-6 2 5-9 4 9 4-2 4-9-6 2 10h-6Z"
          />
          <path stroke="#2CDDE9" strokeWidth="3" d="M517 327H198a33 33 0 0 0 0 66h319a33 33 0 0 0 0-66Z" />
        </g>
        {/* Hand */}
        <motion.g
          initial={{ rotate: 0, translateX: 425 }}
          animate={
            isAnimated ? { rotate: [0, 5, -5, 0], translateX: 425, translateY: [-120, -125, -110, -115] } : undefined
          }
          transition={{ repeat: Infinity, repeatDelay: 2 }}
          transform="translate(425 -120)"
        >
          <path
            opacity="0.2"
            d="M144.681 464.321C149.413 474.499 159.982 471.145 163.835 467.373C167.688 463.6 182.52 445.458 195.008 438.08C207.495 430.694 303.033 375.22 309.909 368.714C316.785 362.208 327.48 351.695 336.04 339.044C344.591 326.394 353.377 313.709 362.196 309.609C371.007 305.501 999 -2.38898 999 -2.38898V-19.5L273.158 339.648L165.183 435.389L144.689 464.321H144.681Z"
            fill="#175DDC"
          />
          <path
            d="M688 -25C688 -25 327.145 202.985 303.183 205.727C279.222 208.468 209.02 206.49 184.564 204.989C160.116 203.497 151.833 210.162 145.962 221.312C140.091 232.462 132.369 252.407 132.369 252.407C132.369 252.407 60.1066 311.654 54.9139 320.348C49.7212 329.042 17.4847 386.57 14.0508 389.823C10.6169 393.076 4.87145 403.262 5.40747 407.965C5.94349 412.669 16.5383 417.892 27.7779 412.082C39.0176 406.272 58.7247 387.099 62.3345 381.205C65.9442 375.311 90.0232 348.5 99.613 342.875C109.203 337.249 111.347 337.241 111.347 337.241C111.347 337.241 109.471 345.792 118.072 350.294C126.674 354.788 178.508 379.36 178.508 379.36C178.508 379.36 150.242 400.697 142.972 416.299C135.702 431.901 133.357 448.844 138.089 459.03C142.821 469.208 153.391 465.855 157.243 462.082C161.096 458.309 175.929 440.167 188.416 432.789C200.904 425.403 296.441 369.929 303.317 363.423C310.193 356.917 320.889 346.404 329.448 333.753C337.999 321.102 346.785 308.418 355.604 304.318C364.415 300.21 1036.5 -32.5 1036.5 -32.5M218.442 343.344C217.588 344.593 215.268 347.218 212.294 350.378C212.294 350.378 208.467 349.733 201.909 348.576C195.351 347.419 164.111 326.929 164.111 326.929C165.259 325.37 166.766 318.193 166.775 318.177C174.379 317.036 181.649 315.578 184.178 314.152C184.178 314.152 210.51 325.915 216.222 332.169C221.934 338.423 221.105 339.471 218.45 343.353L218.442 343.344Z"
            fill="#FFBF00"
          />
          <path
            d="M129.012 247.188C129.012 247.188 150.805 225.399 162.346 224.317C173.887 223.236 173.008 225.961 173.008 225.961"
            stroke="#020F66"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
          <path d="M107.982 332.029L141.802 313.392" stroke="#020F66" strokeWidth="3" strokeMiterlimit="10" />
          <path
            d="M138.226 307.129C138.226 307.129 138.72 315.647 148.854 314.733C158.98 313.811 176.551 311.33 180.798 308.94C180.798 308.94 207.13 320.702 212.842 326.957C218.554 333.211 217.724 334.259 215.069 338.14C212.415 342.014 195.639 359.183 188.805 364.256C181.97 369.328 175.144 374.157 175.144 374.157"
            stroke="#020F66"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
          <path
            d="M163.395 312.956C163.395 312.956 161.879 320.149 160.731 321.709C160.731 321.709 191.971 342.198 198.529 343.355C205.087 344.512 208.915 345.158 208.915 345.158"
            stroke="#020F66"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
          <path d="M140.772 329.472L160.739 321.709" stroke="#020F66" strokeWidth="3" strokeMiterlimit="10" />
          <path
            d="M188.905 404.975C188.905 404.975 196.493 415.949 201.3 418.053"
            stroke="#020F66"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
          <path
            d="M141.55 436.355C141.55 436.355 149.482 426.63 154.708 426.513C159.934 426.396 169.633 433.84 171.006 438.812"
            stroke="#020F66"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
          <path
            d="M8.78459 399.276C8.78459 399.276 16.6658 390.213 14.9907 385.543C13.3156 380.874 12.7964 381.687 12.7964 381.687"
            stroke="#020F66"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
          <path
            d="M663 -17C663 -17 323.781 197.757 299.811 200.499C275.849 203.24 205.647 201.262 181.191 199.761C156.744 198.269 148.461 204.934 142.589 216.084C136.718 227.234 128.996 247.179 128.996 247.179C128.996 247.179 56.7342 306.426 51.5415 315.12C46.3488 323.814 14.1122 381.342 10.6783 384.595C7.24445 387.848 1.49898 398.034 2.035 402.737C2.57102 407.44 13.1658 412.663 24.4055 406.854C35.6451 401.044 55.3522 381.87 58.962 375.977C62.5718 370.083 86.6508 343.272 96.2405 337.647C105.83 332.021 107.974 332.013 107.974 332.013C107.974 332.013 106.098 340.564 114.7 345.066C123.301 349.56 175.136 374.132 175.136 374.132C175.136 374.132 146.869 395.469 139.599 411.071C132.33 426.673 129.985 443.616 134.717 453.802C139.449 463.98 150.018 460.626 153.871 456.854C157.724 453.081 172.556 434.939 185.044 427.561C197.532 420.175 293.069 364.701 299.945 358.195C306.821 351.689 317.516 341.176 326.076 328.525C334.627 315.874 343.413 303.19 352.232 299.09C361.043 294.982 966.774 -6.21481 975.5 -10.5M215.069 338.116C214.215 339.365 211.895 341.989 208.922 345.15C208.922 345.15 205.094 344.504 198.537 343.348C191.979 342.191 160.739 321.701 160.739 321.701C161.886 320.142 163.394 312.965 163.402 312.948C171.007 311.808 178.277 310.35 180.806 308.924C180.806 308.924 207.138 320.687 212.85 326.941C218.562 333.195 217.733 334.243 215.078 338.125L215.069 338.116Z"
            stroke="#020F66"
            strokeWidth="3"
            strokeMiterlimit="10"
          />
        </motion.g>
        <defs>
          <filter
            id="laptop-group"
            width="420.2"
            height="100.6"
            x="147.4"
            y="317.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="8" />
            <feGaussianBlur stdDeviation="8" />
            <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2_133" />
            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0" />
            <feBlend in2="effect1_dropShadow_2_133" result="effect2_dropShadow_2_133" />
            <feBlend in="SourceGraphic" in2="effect2_dropShadow_2_133" result="shape" />
          </filter>
        </defs>
      </svg>
    </div>
  )
}
